<template>
  <v-dialog v-model="show" persistent width="282" content-class="popup-wrap-1">
    <div class="pa-8 text-center">
      <p class="text-type-1">
        <slot name="noti-text"></slot>
      </p>
      <div class="d-flex justify-center mt-6">
        <slot name="noti-btns"></slot>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    radioColumn: '',
    serchText: '',
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {},
  created() {},
};
</script>
